import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

export const DUPLICATE_MENU_PRODUCT = graphql(`
  mutation DuplicateMenuProduct($id: ID!) {
    duplicateMenuProduct(id: $id) {
      id
      title
      code
      description
      images
      ingredients
      priceMode
      allergics
      enabled
      inStock
      labels
      discountable
      configurations {
        id
        title
        type
        values {
          id
          name
          price
        }
      }
      sectionId
      section {
        id
        name
      }
    }
  }
`);

export function useDuplicateMenuProduct() {
  return useMutation(DUPLICATE_MENU_PRODUCT, {
    refetchQueries: ['GetMenuDetail'],
  });
}
